<template>
  <div>
    <vf-loader v-if="loading" class="container" style="height: 25rem" />
    <div v-else-if="data.result?.length" class="divide-y divide-grey-70">
      <div v-for="item in data.result" :key="item.id">
        <h2 class="py-4 text-center container">
          {{ item.id }} | {{ item.name }}
        </h2>
        <component
          :is="component"
          :content="item"
          page-context
          :section="{ name: 'preview', items: [item] }"
        />
      </div>
    </div>
    <div v-else class="text-center">
      No results.
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ShowcaseData } from '~/api/clients/content/data-contracts'
import { CmsSection } from '#components'
import previewMappings from '#content/mappings/preview'

const { data, loading, docType, attachListeners } = defineProps<{
  attachListeners?: boolean
  loading: boolean
  docType: string
  data: ShowcaseData['content']
}>()

const component = computed(() => (docType && previewMappings[docType]) || CmsSection)

watch(() => data, () => scrollTo({ top: 0, behavior: 'smooth' }))

const onScroll = useDebounceFn(() => {
  parent.postMessage(
    {
      type: 'syncScroll',
      scrollTop: window.scrollY
    },
    '*'
  )
})

const onMessage = (event: MessageEvent) => {
  if (event.data.type === 'syncScroll')
    window.scrollTo({ top: event.data.scrollTop })
}

onMounted(() => {
  if (attachListeners) {
    window.addEventListener('message', onMessage)
    window.addEventListener('scroll', onScroll)
  }
})

onUnmounted(() => {
  if (attachListeners) {
    window.removeEventListener('message', onMessage)
    window.removeEventListener('scroll', onScroll)
  }
})
</script>
